export interface AdvancedSetting {
  eventType: SettingType;
  eventValue: boolean;
}

export enum SettingsGroup {
  TaskStatusAutomation = 'TaskStatusAutomation',
  PhaseAutomation = 'PhaseAutomation',
}

export enum SettingType {
  MarkTaskAsCompletedIfSubTaskIs = 'MARK_PARENT_TASK_TO_COMPLETED_IF_SUBTASK_IS_COMPLETED',
  MarkTaskAsInProgressIfSubTaskIs = 'MARK_PARENT_TASK_TO_IN_PROGRESS_IF_SUBTASK_CHANGES',
  MarkSubTasksAsCompletedIfTaskIs = 'MARK_SUBTASKS_COMPLETED_IF_PARENT_IS_COMPLETED',
  AlignPhaseDates = 'BOUND_PHASE_DATES_TO_TASKS_START_AND_DUE_DATE_BOUNDARIES',
  OtpAuthentication = 'CUSTOMER_AUTHENTICATION_OTP_ENABLED',
}

export const SettingsByGroup = {
  [SettingsGroup.TaskStatusAutomation]: [
    SettingType.MarkSubTasksAsCompletedIfTaskIs,
    SettingType.MarkTaskAsCompletedIfSubTaskIs,
    SettingType.MarkTaskAsInProgressIfSubTaskIs,
  ],
  [SettingsGroup.PhaseAutomation]: [SettingType.AlignPhaseDates],
};
